import { render, staticRenderFns } from "./SingleProvider.vue?vue&type=template&id=0b91d01e&scoped=true&"
import script from "./SingleProvider.vue?vue&type=script&lang=js&"
export * from "./SingleProvider.vue?vue&type=script&lang=js&"
import style0 from "./SingleProvider.vue?vue&type=style&index=0&id=0b91d01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b91d01e",
  null
  
)

export default component.exports